<template>
  <div style="width: 100%; height: 100%">
    <!-- <el-select
      v-model="value"
      placeholder="请选择"
      class="m-select"
      @change="changevalue"
    >
      <el-option
        v-for="item in options"
        :key="item.index"
        :label="JSON.stringify(item)"
        :value="JSON.stringify(item)"
      >
      </el-option>
    </el-select> -->
    <div class="pie" ref="place_ref"></div>
  </div>
</template>

<script>
import api from "@/services/api";
export default {
  props: {
    echartsList: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      mychart: null,
      tableData: {},
      options: [],
      value: "",
      ojectList: {
        1: "新闻资讯",
        2: "热搜事件",
        3: "社交评论",
      },
      emotionList: {
        1: "正面情绪",
        2: "负面情绪",
        3: "不确定",
      },
    };
  },
  watch: {
      echartsList(){
        this.tableData={}
        // this.options=[]
        this.tableData = this.echartsList
        this.updateData();
        // this.options = this.echartsList.res.emotion.map((item) => item)
        // console.log(this.tableData,"饼图数据");
        // this.changevalue()
      }
  },
  mounted() {
    if(this.echartsList){ // 放大的框框调用第一条
     this.tableData = this.echartsList;
     this.initchart()
     this.updateData()
    }else{
      this.getData();
      this.initchart();
    }
  },
  methods: {
    // changevalue(val) {
    //   if (!val) return;
    //   this.tableData = JSON.parse(val);
    //   this.updateData();
    // },
    initchart() {
      this.mychart = this.echarts.init(this.$refs.place_ref);
    },
    updateData() {
      const num = this.tableData.value;
      const name = this.tableData.key;
      const chart = this.tableData.chart
      // console.log(num,name);
      const data = [];
      for (var i = 0; i < num.length; i++) {
        data.push({
          value: num[i],
          name: name[i],
        });
      }
      const option = {
        // legend: {
        //   itemHeight: 7,
        //   itemWidth: 7,
        //   top: "top",
        //   left: "left",
        //   orient: "vertical", //纵向
        //   textStyle: {
        //     color: "#7ec7ff",
        //     fontSize: 10
        //   },
        // },
        // title: {
        //   text: "用户发帖统计",
        //   left: "center",
        //   textStyle: {
        //     fontsize: 20,
        //     color: "#000",
        //   },
        // },
        tooltip: {
          trigger: "item",
        },
         toolbox: {
          feature: {
            saveAsImage: {},
            magicType: {
              type: chart,
            },
          },
        },
        series: [
          {
            // name: "个用户发帖数量",
            type: "pie",
            center: ["50%", "50%"],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: data,
          },
        ],
      };
      this.mychart.setOption(option);
    },
    getData() {
       const param = {
        domain_id: 1,
        info_category_id: 1,
        statistic_kind: 3,
        region_id: 0,
        event_id: 0,
        if_total: false,
      }
        const params = {
       name:"热搜事件分析"
      }
      api.region_information.summarize(param,{params}).response.then((res) => res.data).then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.updateData();
          }
        });
    },
  },
};
</script>

<style scoped>
.pie {
  width: 100%;
  height: 100%;
}
</style>